import React, { useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { DeviceDetectContext } from 'providers';

const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export const withDetectDevice = WrappedComponent => {
  const WithDetectDevice = props => {
    const context = useContext(DeviceDetectContext);

    return <WrappedComponent {...props} {...context} />;
  };

  WithDetectDevice.displayName = `withDetectDevice(${getDisplayName(
    WrappedComponent
  )})`;

  hoistNonReactStatics(WithDetectDevice, WrappedComponent);

  return WithDetectDevice;
};

export default withDetectDevice;
